import { StyleSheet } from '@react-pdf/renderer'

export const headerStyles = StyleSheet.create({
	container: {
		flexDirection: 'column',
		alignItems: 'stretch',
		paddingTop: 30,
	},
	mutationDetailsContainer: {
		flexDirection: 'row',
		alignItems: 'stretch',
		paddingTop: 10,
		paddingBottom: 10,
	},
	detailColumn: {
		flexDirection: 'column',
		flexGrow: 11,
	},
	linkColumn: {
		flexDirection: 'column',
		flexGrow: 2,
		alignSelf: 'flex-end',
		justifySelf: 'flex-end',
	},
	nameH1: {
		fontSize: 18,
		fontFamily: 'sofiaProBold',
	},
	subtitle: {
		fontSize: 10,
		justifySelf: 'flex-end',
	},
	link: {
		alignSelf: 'flex-end',
		justifySelf: 'flex-end',
	},
})
